












































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ListingDetail } from '@/models/ListingDetail';
import { ParcelDetail } from '@/models/ParcelDetail';
import ShareNetwork from 'vue-social-sharing/types';
import VueClipboard from 'vue-clipboard2';
import VueSocialSharing from 'vue-social-sharing';
import ListingUtil from '../utils/ListingUtil';

Vue.use(VueClipboard);
// @ts-ignore
Vue.use(VueSocialSharing);


@Component
export default class ShareDialog extends Vue {

    public showDialog: boolean = false;
    public showLinkCopiedText: boolean = false;
    public widthThresholdValue: number = 768;
    public heightThresholdValue: number = 400;
    public mode: string = 'LISTING';

    get selectedListingDetail(): ListingDetail {
        return this.$store.state.listings.selectedListingDetail;
    }

    get selectedParcelDetail(): ParcelDetail {
        return this.$store.state.parcels.selectedParcelDetail;
    }

    get config() {
        return this.$store.state.config;
    }

    get isMobile(): boolean {
        return (this.$q.screen.width <= this.widthThresholdValue) || (this.$q.screen.height <= this.heightThresholdValue);
    }

    get sharingProperties() {
        const url = this.listingUrl;
        let description = '';
        let title = '';
        if (this.mode === 'LISTING') {
            title = 'ReMax Listing';
            description = 'Check out this listing!';
            if (this.selectedListingDetail) {
                title = 'ReMax Listing - ' + this.selectedListingDetail.Address;
            }

        } else {
            title = 'ReMax Parcel - ' + this.selectedParcelDetail;
            description = 'Check out this property!';
        }
        const properties = {
            url,
            title,
            description,
        };

        return properties;
    }

    get listingUrl(): string {
        if (this.mode === 'LISTING') {
            if (this.selectedListingDetail && this.selectedListingDetail.MlsNo) {
                return ListingUtil.getListingUrl(this.config.baseFullListingUrl, this.selectedListingDetail);
            } else {
                return 'Listing URL not found.';
            }
        } else if (this.mode === 'PARCEL') {
            if (this.selectedParcelDetail && this.selectedParcelDetail.ParcelData) {
                return window.location.origin + '/map/?pid=' + this.selectedParcelDetail.ParcelData.PID;
            } else {
                return 'Parcel URL not found.';
            }
        }

        return 'URL not found.';
    }

    get networks() {
        const networks = [
            { network: 'email', name: 'Email', icon: 'far fah fa-lg fa-envelope', color: '#333333' },
            { network: 'facebook', name: 'Facebook', icon: 'fab fah fa-lg fa-facebook-f', color: '#1877f2' },
            { network: 'linkedin', name: 'LinkedIn', icon: 'fab fah fa-lg fa-linkedin', color: '#007bb5' },
            { network: 'twitter', name: 'Twitter', icon: 'fab fah fa-lg fa-twitter', color: '#1da1f2' },
            { network: 'whatsapp', name: 'Whatsapp', icon: 'fab fah fa-lg fa-whatsapp', color: '#25d366' },
        ];

        if (this.isMobile) {
            networks.push({ network: 'sms', name: 'SMS', icon: 'far fah fa-lg fa-comment-dots', color: '#333333' });
        }

        return networks;
    }

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        if (action.type === 'showShareDialog') {
            this.onShowDialog(action.payload);
        }
    });

    public onCopy() {
        this.$copyText(this.listingUrl);
        this.showLinkCopiedText = true;
        setTimeout(() => {
            this.showLinkCopiedText = false;
        }, 5000);
    }

    public onShowDialog(mode: string) {
        this.mode = mode;
        this.showDialog = true;
    }
}

